import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { DxDataGridComponent, DxScrollViewComponent, DxDataGridModule, DxSelectBoxModule, DxCheckBoxModule, DxTemplateModule } from 'devextreme-angular';
import { AccionEspecificaService } from '../../../services/formulacion/accion-especifica.service';
import { OperacionService } from '../../../services/formulacion/operacion.service';
import { TareaService } from '../../../services/formulacion/tarea.service';
import { FusService } from '../../../services/formulacion/fus.service';
import { GeneralService } from '../../../services/formulacion/general.service';
import { switchMap } from 'rxjs/operators';
import { UtilHelper } from '../../../_helpers/util';
declare var jQuery: any;
declare var toastr;

@Component({
  selector: 'app-fus',
  templateUrl: './fus.component.html',
  styleUrls: [],
  providers: [AccionEspecificaService, OperacionService, TareaService, FusService, GeneralService]
})
export class FusComponent implements OnInit {
  techoId: string;
  modelFus: any = { id: 0, objeto: '', justificacion: '', techo_id: 0, fuentes: [] };
  AE: any = [];
  operaciones: any = [];
  tareas: any = [];
  fuentes: any = [];
  fuenteMod = 0;
  poaTecho: any;
  clicked: boolean = false;
  dsbo: boolean = true;
  dsbt: boolean = true;
  ff: boolean = false;
  sf: boolean = true;
  hasError: any;

  constructor(private route: ActivatedRoute, private _fs: FusService, private _as: AccionEspecificaService, private _os: OperacionService, private _ts: TareaService, private _gs: GeneralService) {
    this.route.paramMap.pipe(switchMap((params: ParamMap) => this.techoId = params.get('id'))).subscribe();
    this.getPoaTecho();
    this._as.getListAccionEspecificaByTechoId(this.techoId).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) { this.AE = result.data; }
        else { this.AE = []; }
      },
      (error) => { console.log('Error', error); });
    this.resetErrors();
  }

  ngOnInit() {
  }

  getPoaTecho() {
    this._gs.getPoaTechoById(this.techoId).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) { this.poaTecho = result.data; }
        else { this.poaTecho = []; }
      },
      (error) => { console.log('Error', error); });
  }

  getOperacionesByAEId(e: any) {
    if (e.value != undefined && e.value != null) {
      this._os.getListOperacionesByAeId(e.value).subscribe(
        (response) => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) { this.operaciones = result.data; }
          else { this.operaciones = []; }
        },
        (error) => { console.log('Error', error); });
      this.dsbo = false;
    }
    this.fuentes = []; this.tareas = [];
  }

  getTareasByOperacionId(e: any) {
    if (e.value != undefined && e.value != null) {
      this._ts.getListTareasByOperacionId(e.value).subscribe(
        (response) => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) { this.tareas = result.data; }
          else { this.tareas = []; }
        },
        (error) => { console.log('Error', error); });
      this.dsbt = false;
    }
    this.fuentes = [];
  }

  getFuentesByTareaIdFUS(e: any) {
    if (e.value != undefined && e.value != null) {
      this._fs.getPatidasByTareaIdFUS(e.value).subscribe(
        (response) => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) { this.fuentes = result.data; }
          else { this.fuentes = []; }
          this.sf = false;
        },
        (error) => { console.log('Error', error); });
      this.dsbt = false;
      this.fuenteMod = 0;
      this.ff = false;
    }
  }

  saveFus() {
    this.modelFus.fuentes = this.fuentes.filter(o => o.fuente_id == this.fuenteMod).map(o => o.partidas)[0];
    this.modelFus.techo_id = this.techoId;
    if (this.validSave()) {
      this.clicked = true;
      this._fs.postFus(this.modelFus).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.clicked = false;
          }
        },
        (error) => { console.log('Error', error); });
    }
  }

  resetErrors() {
    this.hasError = { objeto: false, justificacion: false };
  }

  validSave() {
    let res = true;
    if (!UtilHelper.validator(this.modelFus.objeto, 'text')) {
      this.hasError.objeto = true; res = false;
    }
    if (!UtilHelper.validator(this.modelFus.justificacion, 'text')) {
      this.hasError.justificacion = true; res = false;
    }
    return res;
  }

  calculaSaldo(fuenteId: number, id: number) {    
    for (var i = 0; i < this.fuentes.length; i++) {
      if (this.fuentes[i].fuente_id == fuenteId) {
        for (var j = 0; j < this.fuentes[i].partidas.length; j++) {
          if (this.fuentes[i].partidas[j].tarea_detalle_financiador_id == id) {
            this.fuentes[i].partidas[j].saldo = (parseFloat(this.fuentes[i].partidas[j].monto) - parseFloat(this.fuentes[i].partidas[j].ejecutado)).toFixed(2);
            if (parseFloat(this.fuentes[i].partidas[j].ejecutado) > 0) {
              this.fuenteMod = fuenteId;
              this.ff = true;
            }
          }
        }
      }
    }
  }
}
